import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, filter, map, mergeMap, of } from 'rxjs';
import { selectSelectedTenantId } from '@wonder-core-ng/tenant-store/tenant.selectors';
import { isNotNull } from '@wonder-core-ng/utils';
import { QueryEngineActions } from './query-engine.actions';
import { QueryEngineApiService } from './query-engine.api.service';

@Injectable()
export class QueryEngineEffects {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(QueryEngineApiService);
  private readonly store = inject(Store);
  loadChartData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(QueryEngineActions.loadChartData),
      concatLatestFrom(() => this.store.select(selectSelectedTenantId).pipe(filter(isNotNull))),
      mergeMap(([{ query }, tenantId]) =>
        this.apiService.loadData<unknown>(query, tenantId).pipe(
          map((data) =>
            QueryEngineActions.loadChartDataSuccess({
              chartId: query.id,
              data,
              isComparative: !!query.isComparative,
            })
          ),
          catchError((error) =>
            of(QueryEngineActions.loadChartDataFailure({ chartId: query.id, error }))
          )
        )
      )
    )
  );

  httpResult$ = createEffect(() =>
    this.actions$.pipe(
      ofType(QueryEngineActions.loadChartDataFailure, QueryEngineActions.loadChartDataSuccess),
      map((res) =>
        QueryEngineActions.httpResult({
          action: 'loadChartData',
          error: (res as { error?: unknown })?.error,
        })
      )
    )
  );
}
